// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tabBodyItemActive":"tabBodyItemActive-ZVpfD7GO","tabBodyItem":"tabBodyItem-2Lq9CG2c"};